import { AWAIT_PLAY_QUEUE, CLEAR, INVALIDATE_PLAY_QUEUE, PLAYBACK_NOT_SUPPORTED, REORDER, SET_BACKGROUND_IMAGE, SET_LYRICS, SET_MEDIA, SET_PLAY_QUEUE_DATA, SET_ACTIVE_QUEUES_DATA, SET_WEB_MEDIA, } from '../actions/Playback';
const initialState = {
    albumName: '',
    subTitle: '',
    subTitleContainerType: '',
    subTitleLink: undefined,
    durationSeconds: 0,
    logo: '',
    artistName: '',
    artwork: '',
    mediaId: '',
    title: '',
    button: {},
    contextMenu: {},
    onBackgroundImageRequired: [],
    hasLyrics: false,
    onLyricsRequired: [],
    onMediaViewed: [],
    onVisualPlayQueueDataRequired: [],
    onActiveQueuesDataRequired: [],
    onMiniTransportViewed: [],
    onPlaybackNotSupported: [],
    npvBackground: '',
    lyrics: undefined,
    playQueue: undefined,
    activeQueuesData: undefined,
    fetchingPlayQueue: false
};
function array_move(arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
}
const reducer = {
    [CLEAR]: (state, action) => initialState,
    [PLAYBACK_NOT_SUPPORTED]: (state, action) => initialState,
    [SET_MEDIA]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, initialState), action.payload.metadata), { npvBackground: '' });
    },
    [SET_WEB_MEDIA]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload.metadata), { onPlaybackNotSupported: action.payload.onPlaybackNotSupported });
    },
    [SET_BACKGROUND_IMAGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { npvBackground: action.payload.image });
    },
    [SET_LYRICS]: (state, action) => {
        return Object.assign(Object.assign({}, state), { lyrics: action.payload.lyrics });
    },
    [SET_PLAY_QUEUE_DATA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { 
            // TODO: delete "|| action.payload.playQueueTemplate" once CQE code is merged into prod
            // @ts-ignore
            playQueue: action.payload.overlayTemplate || action.payload.playQueueTemplate, fetchingPlayQueue: false });
    },
    [SET_ACTIVE_QUEUES_DATA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { activeQueuesData: action.payload.overlayTemplate, fetchingPlayQueue: false });
    },
    [INVALIDATE_PLAY_QUEUE]: (state) => {
        return Object.assign(Object.assign({}, state), { playQueue: undefined });
    },
    [AWAIT_PLAY_QUEUE]: (state) => {
        return Object.assign(Object.assign({}, state), { fetchingPlayQueue: true });
    },
    [REORDER]: (state, action) => {
        var _a, _b;
        if ((_b = (_a = state) === null || _a === void 0 ? void 0 : _a.playQueue) === null || _b === void 0 ? void 0 : _b.widgets) {
            const playQueueWidget = state.playQueue.widgets[0];
            const items = [...playQueueWidget.items];
            array_move(items, action.payload.fromIndex, action.payload.toIndex);
            playQueueWidget.items = items;
            return Object.assign(Object.assign({}, state), { playQueue: Object.assign(Object.assign({}, state.playQueue), { widgets: [playQueueWidget] }) });
        }
        else {
            return state;
        }
    },
};
export function MediaReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
